import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import Swal from 'sweetalert2';
import { UtilService } from './../../services/util.service';
import { WidgetService } from './../../services/widget.service';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { UserCardComponent } from '../../components/cards/user-card/user-card.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-collegue-you-may-know',
  standalone: true,
  imports: [
    CommonModule,
    CommonProfileInfoComponent,
    UserCardComponent
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './collegue-you-may-know.component.html',
  styleUrls: ['./collegue-you-may-know.component.scss']
})
export class CollegueYouMayKnowComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'Colleagues you may know';

  headerTitle: string = 'Colleagues you may know';
  user: any = [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }];
  responseData = []
  commonDatahide: any = {}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  @Input() maxMin: any = {};
  @Input() page: string;
  @Input() inputData: string;
  viewType: string = "MIN";
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  constructor(private auth: ApiService, private a_route: ActivatedRoute, private router: Router, private widget: WidgetService, private util: UtilService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if (res.master && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })
    this.getConnectSuggestion();
  }
  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = "Colleagues you may know";
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "CollegueYouMayKnowComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  getConnectSuggestion() {
    // this.hide(true)
    this.util.startLoader()
    this.auth.query("business/collegues/connect/suggestion/" + localStorage.getItem('businessId')).subscribe((res) => {
      this.util.stopLoader()
      if (res && res.length != 0 && res != null) {
        if (res.data && res.data.length != 0 && res.data != null && res.data.ColleguesList != null && res.data.ColleguesList.length != 0) {
          this.responseData = res.data.ColleguesList == null ? [] : res.data.ColleguesList;
          this.hide(false)
        } else {
          this.responseData = [];
          this.hide(false) // Show widget with empty message instead of hiding
        }
      } else {
        this.responseData = [];
        this.hide(false) // Show widget with empty message instead of hiding
      }
    }, err => {
      this.util.stopLoader()
      this.responseData = [];
      this.hide(false) // Show widget with empty message instead of hiding
    });
  }

  connect(user: any) {
    this.widget.connectService(user.userId).subscribe(conData => {
      this.util.stopLoader();
      if (conData.code === '00000') {
        this.getConnectSuggestion();
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Connection request sent successfully',
          showConfirmButton: false,
          timer: 3000
        })
      } else if (conData.code === '88888') {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: "Request failed",
          text: 'Connection request failed. Please try again later.',
          showConfirmButton: false,
          timer: 1500
        })
      }
    });
  }

  hide(flag) {
    this.commonDatahide.widgetName = "CollegueYouMayKnowComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }
}

